import calculateThumborUrl from 'helpers/calculateThumborUrl'

export const API_HOST = process.env.API_HOST || ''
export const MAILTO = '?subject=:subject&body=:body'

export const URL_ABOUT = '/team.json'
export const URL_CURRENT_AWARENESS = 'secure/api/:aol/news/articles/:fromDate/:toDate'
export const URL_CURRENT_AWARENESS_PREPAY = 'api/:aol/news/articles/:fromDate/:toDate'
export const URL_CURRENT_AWARENESS_HOMEPAGE = 'api/:aol/service/ca/homepage-articles'
export const URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE = 'secure/api/:aol/service/ca/homepage-article/id/:id'
export const URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY = 'api/:aol/service/ca/homepage-article/id/:id'
export const URL_CURRENT_AWARENESS_SEARCH = 'secure/api/internal/news/search/(browse/:fromDate/:toDate)(:search)'
export const URL_CURRENT_AWARENESS_SEARCH_PREPAY = 'api/internal/news/search/(browse/:fromDate/:toDate)(:search)' // to not send a date you have to set search='search'
export const URL_CURRENT_AWARENESS_ARTICLE = 'secure/api/:aol/news/articles/id/:id'
export const URL_FEEDBACK = 'secure/api/service/feedback'
export const URL_GUIDE = 'static/:fileName'
export const URL_SECURE_GUIDE = 'secure/static/:fileName'
export const URL_GUIDES = 'static-content/api/folders'
export const URL_FEATURED_GUIDES = 'static-content/api/featured'
export const URL_PUBLISHED_CA_KEY_PICKS_PREPAY = 'api/:aol/service/ca/key-picks'
export const URL_PUBLISHED_CA_KEY_PICKS = 'secure/api/:aol/service/ca/key-picks'
export const URL_CA_KEY_PICK_ARTICLE = 'news/:aol/archive/id/:id'
export const URL_LEGISLATION_ACT = 'secure/api/internal/legislation/:act'
export const URL_LEGISLATION_ACTS = 'api/internal/legislation/list?complete=true'
export const URL_LEGISLATION_FOLDERS = 'api/internal/legislation/folders?complete=true'
export const URL_LEGISLATION_CHAPTER = 'secure/api/service/legislation/chapter/:section/:chapter/:act(/:schedule)'
export const URL_LEGISLATION_PART = 'secure/api/service/legislation/part/:part/:act(/:schedule)'
export const URL_LEGISLATION_REFERENCE = 'secure/api/internal/legislation/:references'
export const URL_LEGISLATION_RELATED_QAS = 'secure/api/service/legislation/referenceqa/:flavour/(schedule-:schedule-)(part-:part-)(section-:section)/1/100'
export const URL_LEGISLATION_SCHEDULE = 'secure/api/service/legislation/schedule/:schedule/:act'
export const URL_LEGISLATION_SEARCH = 'secure/api/internal/legislation/search'
export const URL_LEGISLATION_SEARCH_PREPAY = 'api/internal/legislation/search'
export const URL_LEGISLATION_SECTION = 'secure/api/service/legislation/section/:section/:act(/:schedule)'
export const URL_LEGISLATION_TOC = 'secure/api/service/legislation/toc/:act'
export const URL_LOGOUT = 'secure/api/auth/logout'
export const URL_METADATA = 'secure/api/:aol/precedents/service/document(/:id)'
export const URL_CLARILIS_DOCUMENTS = '/secure/api/docs/partner-automated-docs'
export const URL_METADATA_SEARCH = 'secure/api/:aol/precedents/search/metadata'
export const URL_DOCUMENT_DOWNLOAD = 'secure/api/:aol/precedents/service/data/:id'
export const URL_DOCUMENT = 'secure/api/:aol/precedents/service/document(/:id)'
export const URL_DOCUMENTS = 'secure/api/:aol/precedents/search/metadata'
export const URL_DOCUMENTS_PREPAY = 'api/:aol/precedents/search/metadata'
export const URL_DOCUMENT_SECTIONS = 'api/:aol/service/sections/documents'
export const URL_AUTOMATED_DOCUMENTS = 'secure/docs/api/auto/templates/automated'
export const URL_AUTOMATED_DOCUMENTS_PREPAY = 'docs/api/auto/templates/automated'
export const URL_STATIC_DOCUMENTS = 'api/:aol/docs/static-docs'
export const URL_STATIC_DOCUMENTS_METADATA = 'secure/docs/api/static/metadata'
export const URL_STATIC_DOCUMENTS_METADATA_PREPAY = 'docs/api/static/metadata'
export const URL_PASSWORD_RESET = 'secure/users-api/users/client-password-reset'
export const URL_PDF = 'secure/api/pdfservice'
export const URL_PDF_CA = 'secure/api/:aol/ca/pdf/:short'
export const URL_PDF_LEG = 'secure/api/internal/legislation/pdf/:short'
export const URL_PDF_QA = 'secure/api/:aol/qa/pdf/:short'
export const URL_PRINT = 'secure/api/prettyprint(/:short)'
export const URL_WORD_QA = 'secure/api/internal/qa/api/docx'
export const URL_CASE_REFS_CHAPTER = 'secure/api/internal/qa/case-refs/chapter/:chapterId'
export const URL_QA_CONTENT = 'secure/api/internal/qa/questions/:sections'
export const URL_QA_CONTENT_PREPAY = 'api/internal/qa/questions/:sections'
export const URL_QA_INSTANTSEARCH = 'secure/api/service/autocomplete/:flavour/:queryString/0/10'
export const URL_QA_REFERENCES = 'secure/api/internal/legislation/:references'
export const URL_QA_SEARCH = 'secure/api/internal/qa/service/search/:flavour'
export const URL_QA_SEARCH_PREPAY = 'api/internal/qa/service/search/:flavour'
export const URL_QA_SECTIONS = 'secure/api/internal/qa/sections/:flavour'
export const URL_QA_SECTIONS_PREPAY = 'api/internal/qa/sections/:flavour'
export const URL_SEARCH_HISTORY = 'secure/api/service/search-history(/:length)'
export const URL_VECTOR_SEARCH = 'api/search/vector-search'
export const URL_SHORTENER = 'shorty/api/resource(/:short)'
export const URL_TAKEOVER_CODE = 'secure/takeover/code(/:versionId)'
export const URL_TAKEOVER_CODE_VERSIONS = 'secure/takeover/codes'
export const URL_TAKEOVER_CODE_COPY = 'secure/takeover/copy'
export const URL_TAKEOVER_CODE_PUBLISH = 'secure/takeover/version'
export const URL_TAKEOVER_CODE_EDIT_TITLE = 'secure/takeover/section'
export const URL_TAKEOVER_CODE_EDIT_PARAGRAPH = 'secure/takeover/paragraph'
export const URL_TAKEOVER_CODE_DELETE_PARAGRAPH = 'secure/takeover/paragraph/:paragraphId'
export const URL_TAKEOVER_CODE_CREATE_PARAGRAPH = 'secure/takeover/paragraph'
export const URL_TAKEOVER_CODE_EDIT_PREFIX = 'secure/takeover/textPrefix'
export const URL_TAKEOVER_CODE_DELETE_PREFIX = 'secure/takeover/textPrefix/:textPrefixId'
export const URL_TAKEOVER_CODE_CREATE_PREFIX = 'secure/takeover/textPrefix'
export const URL_TRACKING = 'secure/api/service/tracking'
export const URL_USER = 'secure/api/auth/current-user'
export const URL_EMAIL_PREFERENCES = 'secure/users-api/customer/email-preferences'
export const URL_USER_AUTH = 'secure/api/auth/external-auth'
export const URL_IDP_LOGIN = '/gw/'
export const TAKEOVER_INTERNAL = 'TAKEOVER+CODE'
export const URL_CLARILIS_LINK = 'secure/api/user/clarilis-link'
export const URL_CLARILIS_LINK_PREPAY = 'api/user/clarilis-link'
export const URL_CLARILIS_DOCS = 'secure/api/user/doc-auto-suites'
export const URL_CLARILIS_DOCS_PREPAY = 'api/user/doc-auto-suites'
// saved documents only in corporate at the moment
export const URL_DOC_DRAFTER_SAVED_DOCUMENTS = 'secure/api/corporate/docs/sso/saved-documents'
export const URL_DOC_DRAFTER_DOCUMENT_INTERVIEW = 'secure/api/:aol/docs/sso/template/:id'
export const URL_THUMBOR = calculateThumborUrl // calculating this is work so i moved it to its own file
export const URL_MW_EVENT_TYPES = 'api/mw-config/configuration/marketevent/type'
export const URL_MW_FEATURED_DEAL = 'mw-analytics/api/events/featured'
export const URL_MW_STATS_SUMMARY = 'mw-analytics/api/stats/summary'
export const URL_MW_LATEST_DEALS = 'mw-analytics/api/events/latest'
export const URL_MW_EVENT_CONFIGURATION = 'api/mw-config/configuration/marketevent/:type'
export const URL_MW_SHARED_EVENTS_CONFIGURATION = 'api/mw-config/configuration/marketevent/parametergroup'
export const URL_MW_LIST_DEALS = 'mw-analytics/api/events'
export const URL_MW_STATS = 'secure/mw-analytics/api/stats'
export const URL_MW_DEAL = 'secure/mw-analytics/api/events/:dealId'
export const URL_MW_DEAL_DOCUMENT = 'secure/mw-analytics/api/events/:dealId/download/:docId'
export const URL_DOWNLOAD_DEAL_PDF = 'secure/mw-analytics/api/events/:dealId/pdf'
export const URL_DOWNLOAD_DEAL_ZIP = 'secure/mw-analytics/api/events/:dealId/download'
export const URL_DOWNLOAD_DEAL_EXCEL = 'secure/mw-analytics/api/events/:dealId/excel'
export const URL_DOWNLOAD_DEAL_COMPARISON_EXCEL = 'secure/mw-analytics/api/events/compare?events=:deals&parameterName=:parameters'
export const URL_MW_SCOPE_OF_SERVICE = 'secure/mw-analytics/api/documentation'
export const URL_USER_UPSERT = 'secure/users-api/users'
export const URL_ACCESS_ROLES = 'secure/users-api/access-roles'
export const URL_USER_FAVOURITES = 'secure/api/user/favourites'
export const URL_AOL_PREFERENCES = 'secure/api/user/areaoflaw/preferences'
export const URL_PRIMARY_AOL = 'secure/api/user/areaoflaw'
export const URL_PRACTISING_AOL = 'secure/users-api/customer/practising-aol'
export const URL_PARTNER_CONSENT_DETAILS = 'partner/oauth2/consent/details'
export const URL_PARTNER_CONSENT_DECISION = 'partner/oauth2/consent/decision'
